import {
  trigger,
  transition,
  animate,
  style,
  query,
  group,
  keyframes, animateChild,
} from '@angular/animations';

// const fadeIn = [
//   query(':leave', style({ opacity: 1, position: 'absolute' }), {
//     optional: true,
//   }),
//   query(':enter', style({ opacity: 0 }), { optional: true }),
//   query(
//     ':leave',
//     animate('300ms ease-in-out', style({ opacity: 0, visibility: 'hidden' })),
//     { optional: true }
//   ),
//   query(
//     ':enter',
//     animate('500ms ease-in-out', style({ opacity: 1, visibility: 'visible' })),
//     { optional: true }
//   ),
// ];

// export const RouteAnimation = trigger('routeAnimation', [
//   transition('* => *', fadeIn),
// ]);

// export const inOutAnimation = trigger('inOutAnimation', [
//   transition(':enter', [
//     style({ width: 0, maxWidth: 0, opacity: 0 }),
//     animate('.5s', keyframes([style({ width: '1.5rem', opacity: 1 })])),
//   ]),
//   transition(':leave', [
//     style({ width: '1.5rem', opacity: 1 }),
//     animate('.5s', keyframes([style({ width: 0, opacity: 0 })])),
//   ]),
// ]);

export const RouteSlider = trigger('routeSlideAnimation', [
  transition('* => isLeft', slideTo('left')),
  transition('* => isRight', slideTo('right')),
  transition('isRight => *', slideTo('left')),
  transition('isLeft => *', slideTo('right')),
  transition('email => enter-password', slideTo('right')),
  transition('enter-password => email', slideTo('left')),
  transition('new-email => email', slideTo('left')),
  transition('email => *', slideTo('right')),
  transition('* => email', slideTo('left')),
  transition('new-email => enter-password', slideTo('right')),
  transition('enter-password => recover-confirm-email', slideTo('right')),
  transition('recover-confirm-email => enter-password', slideTo('left')),
  transition('confirm-email => register-password', slideTo('right')),
  transition(
    'recover-confirm-email => recover-register-password',
    slideTo('right')
  ),
  transition('* => enter-password', slideTo('left')),
  transition('new-email => email', slideTo('left')),
  transition('new-email => *', slideTo('right')),
  transition('* => new-email', slideTo('left')),
  transition('* => register', slideTo('right')),
  transition('* => register-done', slideTo('right')),
  transition('* => recover-done', slideTo('right')),
]);

function slideTo(direction: string) {
  const optional = { optional: true };
  return [
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          [direction]: 0,
          width: '100%',
          height: '100%',
        }),
      ],
      optional
    ),
    query(':enter', [style({ [direction]: '-100%' })], optional),
    group([
      query(
        ':leave',
        [animate('600ms ease', style({ [direction]: '100%' }))],
        optional
      ),
      query(
        ':enter',
        [animate('600ms ease', style({ [direction]: '0%' }))],
        optional
      ),
    ])
  ];
}
